import { useSearchParams, useRouter } from 'next/navigation';

const DEFAULT_PAGINATION_LIMIT = 20;
export const usePagination = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const page = Number(searchParams?.get('page') || '1');
  const limit = Number(searchParams?.get('limit') || DEFAULT_PAGINATION_LIMIT.toString());
  const startingAfter = searchParams?.get('starting_after') || '';
  const endingBefore = searchParams?.get('ending_before') || '';

  const handlePageChange = (
    newPage: number,
    startingAfter: string,
    endingBefore: string,
    limit?: number
  ) => {
    let d: Record<string, string | string[]> = {};

    if (searchParams) {
      for (const key of searchParams.keys()) {
        d[key] = searchParams.getAll(key);
      }
    }

    d = {
      ...d,
      page: newPage.toString(),
      limit: limit?.toString() || DEFAULT_PAGINATION_LIMIT.toString(),
      starting_after: startingAfter,
      ending_before: endingBefore,
    };

    if (newPage > page) {
      // set starting after
      d.starting_after = startingAfter;
      d.ending_before = '';
    } else {
      // set ending before
      d.ending_before = endingBefore;
      d.starting_after = '';
    }

    // update it in url
    const url = new URL(window.location.href);
    for (const key in d) {
      url.searchParams.set(key, d[key] as string);
    }
    router.push(url.pathname + url.search);

    return d;
  };

  const clearPagination = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('starting_after');
    url.searchParams.delete('ending_before');
    url.searchParams.delete('limit');
    url.searchParams.delete('page');
    router.push(url.pathname + url.search);
  };

  return { page, limit, startingAfter, endingBefore, handlePageChange, clearPagination };
};
